var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "div",
        {
          staticClass: "fixedButton",
          staticStyle: { "margin-bottom": "10px" },
        },
        [
          _c(
            "vxe-button",
            { staticClass: "examineButton", on: { click: _vm.ReturnFun } },
            [_vm._v("返回")]
          ),
          _vm.editFlag
            ? _c(
                "vxe-button",
                {
                  staticClass: "examineButton",
                  attrs: { status: "primary" },
                  on: { click: _vm.onSubmit },
                },
                [_vm._v("提交")]
              )
            : _vm._e(),
          _vm.approveFlag && _vm.approveBtnType === "1"
            ? _c(
                "vxe-button",
                {
                  staticClass: "examineButton",
                  attrs: { status: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.handleApprove(1)
                    },
                  },
                },
                [_vm._v("同意")]
              )
            : _vm._e(),
          _vm.approveFlag && _vm.approveBtnType === "1"
            ? _c(
                "vxe-button",
                {
                  staticClass: "examineButton",
                  attrs: { status: "danger" },
                  on: {
                    click: function ($event) {
                      return _vm.handleApprove(2)
                    },
                  },
                },
                [_vm._v("不同意")]
              )
            : _vm._e(),
        ],
        1
      ),
      _c("div", { staticClass: "item-line" }, [_vm._v("活动提报信息")]),
      _c(
        "div",
        { staticClass: "budgetBox bodyBox" },
        [
          _c(
            "el-form",
            {
              ref: "signUpForm",
              staticClass: "UniformCss",
              attrs: {
                inline: true,
                "label-width": "120px",
                model: _vm.applyForm,
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "sign-tiem",
                          attrs: { label: "申报月份", prop: "actMonth" },
                        },
                        [
                          _c("el-date-picker", {
                            attrs: {
                              "value-format": "yyyy-MM",
                              type: "month",
                              disabled: "",
                            },
                            model: {
                              value: _vm.applyForm.actMonth,
                              callback: function ($$v) {
                                _vm.$set(_vm.applyForm, "actMonth", $$v)
                              },
                              expression: "applyForm.actMonth",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "sign-tiem",
                          attrs: { label: "活动提报名称" },
                        },
                        [
                          _c(
                            "el-tooltip",
                            {
                              staticClass: "item",
                              attrs: {
                                effect: "dark",
                                content: _vm.applyForm.planApplyName,
                                placement: "top",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: { disabled: "" },
                                model: {
                                  value: _vm.applyForm.planApplyName,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.applyForm,
                                      "planApplyName",
                                      $$v
                                    )
                                  },
                                  expression: "applyForm.planApplyName",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "sign-tiem",
                          attrs: { label: "活动提报编码" },
                        },
                        [
                          _c("el-input", {
                            attrs: { disabled: "", placeholder: "" },
                            model: {
                              value: _vm.applyForm.planApplyCode,
                              callback: function ($$v) {
                                _vm.$set(_vm.applyForm, "planApplyCode", $$v)
                              },
                              expression: "applyForm.planApplyCode",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "sign-tiem",
                          attrs: { label: "提报类型" },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { disabled: true },
                              model: {
                                value: _vm.applyForm.itemType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.applyForm, "itemType", $$v)
                                },
                                expression: "applyForm.itemType",
                              },
                            },
                            _vm._l(
                              _vm.SelectLists.TypesOfPresentation,
                              function (tiem, i) {
                                return _c("el-option", {
                                  key: i,
                                  attrs: {
                                    value: tiem.code,
                                    label: tiem.value,
                                  },
                                })
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "sign-tiem",
                          attrs: { label: "提报时间" },
                        },
                        [
                          _c("el-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.applyForm.applyTime,
                              callback: function ($$v) {
                                _vm.$set(_vm.applyForm, "applyTime", $$v)
                              },
                              expression: "applyForm.applyTime",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "act-item",
                          attrs: {
                            label: "原计划开始日期",
                            prop: "planStartTime",
                          },
                        },
                        [
                          _c("el-date-picker", {
                            attrs: {
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              type: "date",
                              disabled: "",
                            },
                            model: {
                              value: _vm.applyForm.planStartTime,
                              callback: function ($$v) {
                                _vm.$set(_vm.applyForm, "planStartTime", $$v)
                              },
                              expression: "applyForm.planStartTime",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "sign-tiem",
                          attrs: {
                            label: "原计划结束日期",
                            prop: "planEndTime",
                          },
                        },
                        [
                          _c("el-date-picker", {
                            attrs: {
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              type: "date",
                              disabled: "",
                            },
                            model: {
                              value: _vm.applyForm.planEndTime,
                              callback: function ($$v) {
                                _vm.$set(_vm.applyForm, "planEndTime", $$v)
                              },
                              expression: "applyForm.planEndTime",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "sign-tiem",
                          attrs: { label: "活动预算(元)", prop: "actBudget" },
                        },
                        [
                          _c("el-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.applyForm.actBudget,
                              callback: function ($$v) {
                                _vm.$set(_vm.applyForm, "actBudget", $$v)
                              },
                              expression: "applyForm.actBudget",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "sign-tiem",
                          attrs: { label: "提报状态" },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { disabled: "" },
                              model: {
                                value: _vm.applyForm.applyStatus,
                                callback: function ($$v) {
                                  _vm.$set(_vm.applyForm, "applyStatus", $$v)
                                },
                                expression: "applyForm.applyStatus",
                              },
                            },
                            _vm._l(
                              _vm.SelectLists.ActPlanApplyStatus,
                              function (tiem, i) {
                                return _c("el-option", {
                                  key: i,
                                  attrs: {
                                    value: tiem.code,
                                    label: tiem.value,
                                  },
                                })
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "sign-tiem",
                          attrs: { label: "集客目标" },
                        },
                        [
                          _c("el-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.applyForm.customerTarget,
                              callback: function ($$v) {
                                _vm.$set(_vm.applyForm, "customerTarget", $$v)
                              },
                              expression: "applyForm.customerTarget",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "sign-tiem",
                          attrs: { label: "订单目标" },
                        },
                        [
                          _c("el-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.applyForm.orderTarget,
                              callback: function ($$v) {
                                _vm.$set(_vm.applyForm, "orderTarget", $$v)
                              },
                              expression: "applyForm.orderTarget",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "act-item",
                          attrs: {
                            label: "新计划开始日期",
                            prop: "newStartTime",
                            rules: [
                              {
                                required: true,
                                message: "请选择开始时间!",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("el-date-picker", {
                            attrs: {
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              type: "date",
                              "picker-options": {
                                disabledDate: function (time) {
                                  return (
                                    time.getTime() <
                                      (+new Date(_vm.activity.planStartTime) >
                                      Date.now()
                                        ? +new Date(
                                            _vm.activity.planStartTime
                                          ) - 8.64e7
                                        : Date.now() - 8.64e7) ||
                                    time.getTime() >
                                      +new Date(_vm.activity.planEndTime)
                                  )
                                },
                              },
                              placeholder: "选择日期",
                              disabled: _vm.approveFlag,
                            },
                            on: {
                              change: function ($event) {
                                _vm.applyForm.newEndTime &&
                                  (_vm.applyForm.newEndTime = "")
                              },
                            },
                            model: {
                              value: _vm.applyForm.newStartTime,
                              callback: function ($$v) {
                                _vm.$set(_vm.applyForm, "newStartTime", $$v)
                              },
                              expression: "applyForm.newStartTime",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "sign-tiem",
                          attrs: {
                            label: "新计划结束日期",
                            prop: "newEndTime",
                            rules: [
                              {
                                required: true,
                                message: "请选择结束时间!",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("el-date-picker", {
                            attrs: {
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              "picker-options": {
                                disabledDate: function (time) {
                                  return (
                                    time.getTime() <
                                      new Date(
                                        _vm.applyForm.newStartTime
                                          ? _vm.applyForm.newStartTime
                                          : ""
                                      ) ||
                                    time.getTime() >
                                      +new Date(_vm.activity.planEndTime)
                                  )
                                },
                              },
                              type: "date",
                              placeholder: "选择日期",
                              disabled: _vm.approveFlag,
                            },
                            model: {
                              value: _vm.applyForm.newEndTime,
                              callback: function ($$v) {
                                _vm.$set(_vm.applyForm, "newEndTime", $$v)
                              },
                              expression: "applyForm.newEndTime",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "item-line" }, [_vm._v("计划时间调整记录")]),
      _c(
        "div",
        { staticClass: "budgetBox bodyBox" },
        [
          _c(
            "vxe-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              ref: "xTable",
              staticClass: "mytable-scrollbar",
              staticStyle: { "margin-top": "10px" },
              attrs: {
                border: "",
                "show-header-overflow": "",
                "show-overflow": "",
                align: "center",
                "column-config": { resizable: true },
                stripe: "",
                round: "",
                "max-height":
                  _vm.$store.state.app.height - 130 < 180
                    ? 180
                    : _vm.$store.state.app.height - 130,
                "scroll-y": { enabled: false },
                "row-config": { isHover: true },
                data: _vm.adjustList,
              },
            },
            [
              _c("vxe-column", {
                attrs: { type: "checkbox", width: "60", align: "center" },
              }),
              _c("vxe-column", {
                attrs: {
                  type: "seq",
                  title: "序号",
                  width: "60",
                  align: "center",
                },
              }),
              _c("vxe-column", {
                attrs: {
                  field: "oldStartTime",
                  title: "原计划开始时间",
                  width: "120",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("dateFormat")(
                                row.oldStartTime,
                                "yyyy-MM-dd"
                              )
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("vxe-column", {
                attrs: {
                  field: "oldEndTime",
                  title: "原计划结束时间",
                  width: "120",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("dateFormat")(row.oldEndTime, "yyyy-MM-dd")
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("vxe-column", {
                attrs: {
                  field: "newStartTime",
                  title: "新计划开始时间",
                  width: "120",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("dateFormat")(
                                row.newStartTime,
                                "yyyy-MM-dd"
                              )
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("vxe-column", {
                attrs: {
                  field: "newEndTime",
                  title: "新计划结束时间",
                  width: "120",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("dateFormat")(row.newEndTime, "yyyy-MM-dd")
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("vxe-column", {
                attrs: {
                  field: "approveStatus",
                  title: "审核状态",
                  width: "100",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        row.approveStatus === "0"
                          ? _c("span", [_vm._v("未通过")])
                          : row.approveStatus === "1"
                          ? _c("span", [_vm._v("审核中")])
                          : _c("span", [_vm._v("已通过")]),
                      ]
                    },
                  },
                ]),
              }),
              _c("vxe-column", {
                attrs: {
                  field: "approveNode",
                  title: "审批节点",
                  width: "160",
                },
              }),
              _c("vxe-column", {
                attrs: {
                  field: "approveAuditorNames",
                  title: "当前审批人",
                  width: "160",
                },
              }),
              _c("vxe-column", {
                attrs: { field: "createTime", title: "创建时间", width: "160" },
              }),
              _c("vxe-column", {
                attrs: {
                  title: "操作",
                  width: "100",
                  fixed: "right",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "div",
                          { staticClass: "handle-box" },
                          [
                            _c(
                              "el-link",
                              {
                                attrs: {
                                  type: "primary",
                                  icon: "el-icon-view",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.viewApproveDetail(row)
                                  },
                                },
                              },
                              [_vm._v("审核流程")]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "审批信息",
            visible: _vm.dialogVisible,
            width: "40%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("el-input", {
            attrs: {
              type: "textarea",
              placeholder: "请输入审批意见",
              maxlength: "300",
              "show-word-limit": "",
            },
            model: {
              value: _vm.approveMsg,
              callback: function ($$v) {
                _vm.approveMsg = $$v
              },
              expression: "approveMsg",
            },
          }),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "vxe-button",
                {
                  attrs: { loading: _vm.approveBtnLoading, status: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.approve()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.approveTypeName))]
              ),
              _c(
                "vxe-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "审批信息",
            visible: _vm.taskDialogVisible,
            width: "60%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.taskDialogVisible = $event
            },
          },
        },
        [
          _c(
            "vxe-table",
            {
              ref: "xApprove",
              attrs: {
                border: "",
                "show-header-overflow": "",
                "show-overflow": "",
                "column-config": { resizable: true },
                stripe: "",
                round: "",
                loading: _vm.approveLoading,
                "max-height": "370",
                align: "center",
                "scroll-y": { enabled: false },
                data: _vm.taskListData,
                reserve: true,
                "row-config": { isCurrent: true, isHover: true },
              },
            },
            [
              _c("vxe-column", {
                attrs: { type: "seq", title: "序号", width: "60" },
              }),
              _c("vxe-column", {
                attrs: { field: "displayName", title: "节点名称" },
              }),
              _c("vxe-column", {
                attrs: { field: "operatorName", title: "审批人" },
              }),
              _c("vxe-column", {
                attrs: { field: "operateType", title: "操作类型" },
              }),
              _c("vxe-column", {
                attrs: { field: "approveMsg", title: "审批意见" },
              }),
              _c("vxe-column", {
                attrs: { field: "finishTime", title: "处理时间" },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }